import { IProExam } from "./pro-exam.models";

export class GetProExam {
  static readonly type = '[ProExam] Get PRO Exams';
}

export class GetProExamsBySession {
  static readonly type = '[ProExam] Get PRO Exams By Session';
}

export class GetProExamCompletedApplications {
  static readonly type = '[ProExam] Get PRO Exams Completed Applications';
  constructor(public payload: { examId: string, }) { }
}

export class GetProExamCompletedApplicationsSilent {
  static readonly type = '[ProExam] Get PRO Exams Completed Applications Silent';
  constructor(public payload: { examId: string }) { }
}

export class GetSingleProExam {
  static readonly type = '[ProExam] Get Single PRO Exams';
  constructor(public payload: string) { }
}

export class GetSingleProExamByType {
  static readonly type = '[ProExam] Get Single PRO Exams By Type';
  constructor(public payload: { cohortId: string, type: string, isAux: boolean }) { }
}

export class SaveProExam {
  static readonly type = '[ProExam] Add PRO Exams';
  constructor(public payload: any) { }
}

export class UpdateStatusProExam {
  static readonly type = '[ProExam] Update Status PRO Exams';
  constructor(public payload: any) { }
}

export class SelectProExam {
  static readonly type = '[ProExam] Select PRO Exams';
  constructor(public payload: IProExam) { }
}

export class SendPhase2Invitations {
  static readonly type = '[ProExam] Send Phase 2 Invitations';
  constructor(public payload: string) { }
}

export class SendMMIInvitations {
  static readonly type = '[ProExam] Send MMI Invitations'
  constructor(public payload: string) { }
}

export class SetProExamFee {
  static readonly type = '[ProExam] Set PRO Exams Fee';
  constructor(public payload: { id: string, fee: number }) { }
}

export class DeleteProExam {
  static readonly type = '[ProExam] Delete PRO Exams';
  constructor(public payload: string) { }
}

export class AssignInterviewersCohort {
  static readonly type = `[ProExam] Assign Interviewers to Cohort`;
  constructor(public payload: any) { }
}

export class AssignModeratorsCohort {
  static readonly type = `[ProExam] Assign Moderators to Cohort`;
  constructor(public payload: any) { }
}

export class RemoveModeratorCohort {
  static readonly type = `[ProExam] Remove Moderator from Cohort`;
  constructor(public payload: { moderatorId: string, cohortId: string }) { }
}

export class RemoveInterviewerCohort {
  static readonly type = `[ProExam] Remove Interviewer from Cohort`;
  constructor(public payload: { interviewerId: string, cohortId: string }) { }
}

export class GetSingleSupervisor {
  static readonly type = `[ProExam] GET Single Supervisor from userId`;
  constructor(public payload: { userId: string }) { }
}

export class SendFinalDecisionEmail {
  static readonly type = `[ProExam] Final Decision Email`;
  constructor(public payload: string) { }
}

export class SendPhase2FinalDecisionEmail {
  static readonly type = `[ProExam] Final Phase 2 Decision Email`;
  constructor(public payload: string) { }
}
